<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      รีวิวจากลูกค้า
    </div>
    <div class="pt-9">
      <v-card v-for="(job, k) in jobs" :key="k" outlined class="pa-2 pb-4">
        <div style="font-weight: 900; font-size: 11px; margin-bottom: 15px">
          JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
        </div>
        <div class="px-1">
          <div style="display: flex; flex-direction: row">
            <div>
              <img
                style="height: 60px; width: 80px"
                :src="job.customer_profile_pic"
              />
            </div>
            <div style="align-self: center; margin-left: 20px; font-size: 12px">
              <span style="color: green">ผู้รีวิว:</span>
              {{ job.customer_name }}
            </div>
          </div>
          <div>
            มีลูกค้าทำการรีวิวท่านค่ะ โดยรายละเอียดสามารถดูจากด้านล่างได้ค่ะ
          </div>
          <v-row>
            <v-col class="ratingtext pr-0 pb-0" cols="7">
              <div style="font-weight: 900">ความรวดเร็วในการให้บริการ</div>
              <div style="line-height: 10px; font-size: 10px">
                การให้บริการรวดเร็ว ไม่ต้องรอนาน
              </div>
            </v-col>
            <v-col cols="5" class="pl-0 pb-0 text-right">
              <star-rating
                :inline="true"
                :rating="job.speed_of_service"
                :read-only="true"
                :show-rating="false"
                :rounded-corners="true"
                :star-size="18"
                :increment="0.1"
              ></star-rating>
            </v-col>
            <v-col class="ratingtext pr-0 pb-0" cols="7">
              <div style="font-weight: 900">การให้บริการ</div>
              <div style="line-height: 10px; font-size: 10px">
                การให้ความช่วยเหลือและให้คำแนะนำ
              </div>
            </v-col>
            <v-col cols="5" class="pl-0 pb-0 text-right">
              <star-rating
                :inline="true"
                :rating="job.customer_service"
                :show-rating="false"
                :read-only="true"
                :rounded-corners="true"
                :star-size="18"
                :increment="0.1"
              ></star-rating>
            </v-col>
            <v-col class="ratingtext pr-0 pb-0" cols="7">
              <div style="font-weight: 900">ฝีมือและความเชี่ยวชาญ</div>
              <div style="line-height: 10px; font-size: 10px">
                มีความรู้ เชี่ยวชาญในการทำงาน
              </div>
            </v-col>
            <v-col cols="5" class="pl-0 text-right pb-0">
              <star-rating
                :inline="true"
                :rating="job.skill"
                :read-only="true"
                :show-rating="false"
                :rounded-corners="true"
                :star-size="18"
                :increment="0.1"
              ></star-rating>
            </v-col>
            <v-col class="ratingtext pr-0 pb-0" cols="7">
              <div style="font-weight: 900">ความคุ้มค่าของราคา</div>
              <div style="line-height: 10px; font-size: 10px">
                เมื่อเทียบกับราคา และผลงานที่ได้รับ
              </div>
            </v-col>
            <v-col cols="5" class="pl-0 text-right pb-0">
              <star-rating
                :inline="true"
                :rating="job.worthiness"
                :show-rating="false"
                :read-only="true"
                :rounded-corners="true"
                :star-size="18"
                :increment="0.1"
              ></star-rating>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StarRating from "vue-star-rating";
export default {
  props: ["value"],
  components: {
    StarRating,
  },
  computed: {
    jobs() {
      return this.value.orderlist.filter((el) => el.status == "ได้รับการรีวิว");
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  data() {
    return {
      loading: "",
    };
  },
  methods: {},
};
</script>
</script>

<style lang="scss" scoped>
.ratingtext {
  font-size: 12px;
}
</style>